export default "__VITE_ASSET__BWyj$bKP__"